import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  Controller,
  useForm,
  useWatch,
} from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, ModalBody, Table } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  SETTING_KEY,
} from "../../utils/Utils";

const DEFAULT_BILL_EXTERNAL_CONTRACT = {
  name: "",
  customerId: null,
  ingredientId: '',
  contractSignDate: moment().format("YYYY-MM-DD"),
  contractQuantity: 0,
  quantity: 0,
  contractUnitPrice: 0,
  numOfContainer: 0,
  completedDate: null,
  insuranceRate: 0,
  insuranceExchangeRate: 0,
  shipStartDate: null,
  shipFeeUnitPrice: 0,
  shipFeeExchangeRate: 0,
  shipFeebillFee: 0,
  shipFeeSealFeePerContainer: 0,
  shipFeeCustomFee: 0,
  shipFeeVatRate: 0,
  baseFeeExchangeRate: 0,
  baseFeeCommissionFeePerWeightRate: 0,
  baseFeeBankFeePerCont: 0,
  deliveryProvider: [],
  note: '',
  pack: 0,
  deliveryFee: 0,
  liftOnFee: 0,
  liftOffFee: 0,
  inDriverFosteringUpDownContainerFee: 0,
  infrastructureFee: 0,
  bankAccountId: null,
  shipFeeCustomFeeProviderId: null,
  shipFeeProviderId: null,
  commissionProviderId: null,
  insuranceProviderId: null,
  attachFeeUnitPrice: 0,
  packUnitPrice: 0,
  handlerId: null,
  exWarehouseUnitPrice: 0,
};

const BillExternalContractCreate = () => {
  const history = useHistory();
  const location = useLocation();
  const duplicateId = new URLSearchParams(location.search).get("duplicateId");
  const params = useParams();
  const id = duplicateId || params.id;
  const [data, setData] = useState(null)
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [view, setView] = useState({
    createDebt: false,
    createDebtCustomFeeProvider: false,
    createDebtCommissionFee: false,
    removeDebt: false,
    removeDebtCustomFeeProvider: false,
    removeDebtCommissionFee: false,
  });
  const [timeNow, setTimeNow] = useState();

  const onFormCancel = () => {
    setView({
      createDebt: false,
      createDebtCustomFeeProvider: false,
      createDebtCommissionFee: false,
      removeDebt: false,
      removeDebtCustomFeeProvider: false,
      removeDebtCommissionFee: false,
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const methodForm = useForm({
    defaultValues: DEFAULT_BILL_EXTERNAL_CONTRACT,
    shouldFocusError: true,
    mode: 'onChange'
  });

  const {
    reset,
    getValues,
    control,
    register,
    errors,
    handleSubmit,
    formState: {
      isDirty
    }
  } = methodForm;

  const quantity = useWatch({
    control,
    name: "quantity",
  });

  const contractUnitPrice = useWatch({
    control,
    name: "contractUnitPrice",
  });

  const insuranceRate = useWatch({
    control,
    name: "insuranceRate",
  });

  const insuranceExchangeRate = useWatch({
    control,
    name: "insuranceExchangeRate",
  });

  const shipFeeUnitPrice = useWatch({
    control,
    name: "shipFeeUnitPrice",
  });

  const numOfContainer = useWatch({
    control,
    name: "numOfContainer",
  });

  const shipFeeExchangeRate = useWatch({
    control,
    name: "shipFeeExchangeRate",
  });

  const shipFeeCustomFee = useWatch({
    control,
    name: "shipFeeCustomFee",
  });

  const shipFeebillFee = useWatch({
    control,
    name: "shipFeebillFee",
  });

  const shipFeeVatRate = useWatch({
    control,
    name: "shipFeeVatRate",
  });

  const baseFeeExchangeRate = useWatch({
    control,
    name: "baseFeeExchangeRate",
  });

  const baseFeeCommissionFeePerWeightRate = useWatch({
    control,
    name: "baseFeeCommissionFeePerWeightRate",
  });

  const baseFeeBankFeePerCont = useWatch({
    control,
    name: "baseFeeBankFeePerCont",
  });

  const shipFeeSealFeePerContainer = useWatch({
    control,
    name: "shipFeeSealFeePerContainer",
  });

  const deliveryFee = useWatch({
    control,
    name: "deliveryFee",
  });

  const liftOffFee = useWatch({
    control,
    name: "liftOffFee",
  });

  const liftOnFee = useWatch({
    control,
    name: "liftOnFee",
  });

  const inDriverFosteringUpDownContainerFee = useWatch({
    control,
    name: "inDriverFosteringUpDownContainerFee",
  });

  const infrastructureFee = useWatch({
    control,
    name: "infrastructureFee",
  });


  const attachFeeUnitPrice = useWatch({
    control,
    name: "attachFeeUnitPrice",
  });


  const packUnitPrice = useWatch({
    control,
    name: "packUnitPrice",
  });


  const insuranceTax = useWatch({
    control,
    name: "insuranceTax",
  });

  const shipFeeCustomFeeProviderId = useWatch({
    control,
    name: "shipFeeCustomFeeProviderId",
  });

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [listCustomerNoTaxCustomerFee, setListCustomerNoTaxCustomerFee] = useState([]);
  const [deliveryProvider, setDeliveryProvider] = useState([])
  const [userOptions, setUserOptions] = useState([]);
  useEffect(() => {

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET(`bank-account`, {}, true).then((resp) => {
      setBankAccountOptions(
        resp.data.map((c) => ({
          label: `${c.name}`,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/customer", {}, true).then(({ data }) => {
      setCustomerOptions([
        ...data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        })),
      ]);
    });

    GET("/setting", {}, true).then(({ data }) => {
      data.forEach(({ content, key }) => {
        if (key === SETTING_KEY.INTERNAL_CUSTOMER_HANDLE_CUSTOM_FEE) {
          setListCustomerNoTaxCustomerFee(content)
        }
      })
    })

    GET("/user/list-can-handler-external-contract", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  useEffect(() => {
    if (!id) {
      return
    }

    GET(`/bill-external-contract/${id}`, {}, true).then((resp) => {
      let { data: { deliveryProvider, ...data } } = resp;
      const temp = []
      Object.values(deliveryProvider || {}).forEach(provider => {
        Object.values(provider || {}).forEach(e => temp.push(e))
      })
      setData(data)
      reset({
        ...data,
      });
      setDeliveryProvider(temp)
    });
  }, [timeNow, id])

  const contractSubtotal = useMemo(() => {
    return Number((quantity * +(contractUnitPrice || 0).toFixed(4)))
  }, [quantity, contractUnitPrice])

  const insuranceUsdFee = useMemo(() => {
    const insuranceUsdFeeBeforeTax = contractSubtotal * insuranceRate / 100
    return insuranceUsdFeeBeforeTax * Number((1 + (+insuranceTax || 0) / 100).toFixed(4)) || 0;
  }, [
    contractSubtotal,
    insuranceRate,
    insuranceTax
  ])

  const insuranceFee = useMemo(() => {
    return Math.round(insuranceUsdFee * insuranceExchangeRate) || 0;
  }, [insuranceUsdFee, insuranceExchangeRate])

  const shipFeeSubtotal = useMemo(() => {
    const shipFeeUsdSubtotal = numOfContainer * shipFeeUnitPrice
    return Math.round(shipFeeUsdSubtotal * shipFeeExchangeRate)
  }, [numOfContainer, shipFeeUnitPrice, shipFeeExchangeRate])

  const isNoTaxCustomFee = useMemo(() => {
    let tempIsNoTaxCustomFee = false;
    if (shipFeeCustomFeeProviderId) {
      if (listCustomerNoTaxCustomerFee.includes(shipFeeCustomFeeProviderId)) {
        tempIsNoTaxCustomFee = true;
      }
    }
    return tempIsNoTaxCustomFee
  }, [shipFeeCustomFeeProviderId, listCustomerNoTaxCustomerFee])

  const tempSubTotalForCalcTax = useMemo(() => {
    return Math.round((numOfContainer * shipFeeSealFeePerContainer + shipFeebillFee) * shipFeeExchangeRate)
  }, [numOfContainer, shipFeeSealFeePerContainer, shipFeeExchangeRate, shipFeebillFee])

  const shipFeeSubtotalBeforeTax = useMemo(() => {
    return (
      shipFeeSubtotal + tempSubTotalForCalcTax
    )
  }, [
    shipFeeSubtotal,
    tempSubTotalForCalcTax
  ]);

  const shipFeeSubtotalTax = useMemo(() => {
    return tempSubTotalForCalcTax * shipFeeVatRate / 100;
  }, [tempSubTotalForCalcTax, shipFeeVatRate])

  const shipFeeSubtotalIncludeTax = useMemo(() => {
    const tempShipFeeSubtotalIncludeTax = shipFeeSubtotalTax + shipFeeSubtotalBeforeTax;
    return tempShipFeeSubtotalIncludeTax
  }, [shipFeeSubtotalBeforeTax, shipFeeSubtotalTax]);

  const shipFeeCustomFeeTax = useMemo(() => {
    return shipFeeCustomFee * (isNoTaxCustomFee ? 0 : shipFeeVatRate / 100);
  }, [shipFeeCustomFee, isNoTaxCustomFee, shipFeeVatRate])
  const shipFeeCustomFeeAfterTax = useMemo(() => {
    return shipFeeCustomFeeTax + shipFeeCustomFee;
  }, [shipFeeCustomFeeTax, shipFeeCustomFee])
  const baseFeeCommissionFee = useMemo(() => {
    return Math.round(Number(baseFeeCommissionFeePerWeightRate) * Math.floor(quantity) * baseFeeExchangeRate);
  }, [baseFeeCommissionFeePerWeightRate, contractUnitPrice, baseFeeExchangeRate, quantity]);

  const baseFeeBankFee = useMemo(() => {
    return Math.round(baseFeeBankFeePerCont * baseFeeExchangeRate * numOfContainer)
  }, [baseFeeBankFeePerCont, baseFeeExchangeRate, numOfContainer]);

  const attachFee = useMemo(() => {
    return quantity * +(attachFeeUnitPrice || 0);
  }, [attachFeeUnitPrice, quantity]);

  const baseFeePackageFee = useMemo(() => {
    return Math.round(numOfContainer * Number(packUnitPrice || 0) * baseFeeExchangeRate);
  }, [packUnitPrice, numOfContainer, baseFeeExchangeRate]);

  const total = useMemo(() => {
    return Math.round((
      deliveryFee +
      liftOnFee +
      liftOffFee +
      inDriverFosteringUpDownContainerFee +
      infrastructureFee +
      insuranceFee +
      shipFeeSubtotalIncludeTax +
      shipFeeCustomFeeAfterTax +
      baseFeePackageFee +
      baseFeeCommissionFee +
      baseFeeBankFee +
      attachFee
    ) || 0)
  }, [
    deliveryFee,
    liftOnFee,
    liftOffFee,
    inDriverFosteringUpDownContainerFee,
    infrastructureFee,
    insuranceFee,
    shipFeeSubtotalIncludeTax,
    shipFeeCustomFeeAfterTax,
    baseFeePackageFee,
    baseFeeCommissionFee,
    baseFeeBankFee,
    attachFee
  ]);

  const createDebt = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    POST(`bill-external-contract/create-debt/${id}`, {}, {}, true)
      .then((res) => {
        toast.success("Tạo công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const createDebtCommissionFee = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    POST(`bill-external-contract/create-debt-commission-fee/${id}`, {}, {}, true)
      .then((res) => {
        toast.success("Tạo công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const createDebtCustomFeeProvider = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    POST(`bill-external-contract/create-debt-custom-fee/${id}`, {}, {}, true)
      .then((res) => {
        toast.success("Tạo công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const removeDebt = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    DELETE(`bill-external-contract/remove-debt-by-bill-external-contract/${id}`, {}, true)
      .then((res) => {
        toast.success("Xoá công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const removeDebtCommissionFee = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    DELETE(`bill-external-contract/remove-debt-commission-fee-by-bill-external-contract/${id}`, {}, true)
      .then((res) => {
        toast.success("Xoá công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const removeDebtCustomFeeProvider = () => {
    if (!id) {
      return;
    }
    setLoading(true)
    DELETE(`bill-external-contract/remove-debt-custom-fee-by-bill-external-contract/${id}`, {}, true)
      .then((res) => {
        toast.success("Xoá công nợ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const onHandleSubmit = () => {
    setLoading(true);
    const formData = getValues();
    if (!shipFeeCustomFeeProviderId) {
      formData.shipFeeCustomFeeProviderId = null;
    }
    const request =
      id && !duplicateId
        ? PUT(`bill-external-contract/${id}`, formData, {}, true)
        : POST("bill-external-contract", { ...formData }, {}, true);

    request
      .then((res) => {
        if (id) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const reportRevenuePrice = useMemo(() => {
    const rows = []
    warehouseOptions.forEach(warehouse => {
      const unitPrice = ((contractUnitPrice / 1000) || 0) * (data?.billExternalContractEstimate?.exchangeRate || 0);
      const deliveryFeeByWeight = (data?.billExternalContractEstimate?.netFee?.[warehouse.value] || 0) * (data?.billExternalContractEstimate?.exchangeRate || 0);
      const actualNetUnitPrice = unitPrice - deliveryFeeByWeight;
      rows.push({
        warehouse,
        unitPrice,
        deliveryFeeByWeight,
        actualNetUnitPrice
      })
    })
    return rows;
  }, [warehouseOptions, data, contractUnitPrice]);
  return (
    <React.Fragment>
      <Head title="Hợp đồng xuất khẩu"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Hợp đồng xuất khẩu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >

                <div className="my-3">
                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">
                        Thông tin giá net
                      </BlockTitle>
                    </Col>
                    {reportRevenuePrice.map(({
                      warehouse,
                      unitPrice,
                      deliveryFeeByWeight,
                      actualNetUnitPrice
                    }) => <Col md={6}>
                        <Row>
                          <Col size={12}>
                            <h5>Kho {warehouse.label}</h5>
                          </Col>

                          <Col md="4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Đơn giá(đ)
                              </label>
                              <div className="form-control-wrap">
                                <NumericFormat
                                  disabled
                                  className="form-control"
                                  type="text"
                                  value={unitPrice}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Giá vận chuyển
                              </label>
                              <div className="form-control-wrap">
                                <NumericFormat
                                  disabled
                                  className="form-control"
                                  type="text"
                                  value={deliveryFeeByWeight}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Đơn giá kho thực tế
                              </label>
                              <div className="form-control-wrap">
                                <NumericFormat
                                  disabled
                                  className="form-control"
                                  type="text"
                                  value={actualNetUnitPrice}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>)}
                  </Row>


                </div>
                <div className="my-3">
                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">
                        Thông tin hợp đồng xuất khẩu
                      </BlockTitle>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên hợp đồng <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Khách hàng <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="customerId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={customerOptions.filter(e => e.data.type === 'OUT')}
                                value={
                                  customerOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="customerId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Nguyên liệu <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="ingredientId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={ingredientOptions}
                                value={
                                  ingredientOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="ingredientId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Ngày ký hợp đồng
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            rows={3}
                            className="form-control"
                            type="date"
                            name="contractSignDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="contractSignDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Số lượng theo hợp đồng(tấn)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="contractQuantity"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="contractQuantity"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Số lượng thực đóng(tấn)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="quantity"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={3}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="quantity"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Đơn giá số lượng($/tấn)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="contractUnitPrice"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={3}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="contractUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền số lượng($)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="contractSubtotal"
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={quantity * contractUnitPrice}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="contractUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>


                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tiền gửi/tấn($)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="attachFeeUnitPrice"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="attachFeeUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền gửi($)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="attachFee"
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={attachFee}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Số lượng container
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="numOfContainer"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="numOfContainer"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Ngày tàu chạy
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            rows={3}
                            className="form-control"
                            type="date"
                            name="shipStartDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipStartDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Ngày hoàn thành
                        </label>
                        <div className="form-control-wrap">
                          <input
                            rows={3}
                            className="form-control"
                            type="date"
                            name="completedDate"
                            ref={register({})}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="completedDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Ngân hàng
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="bankAccountId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={bankAccountOptions}
                                value={
                                  bankAccountOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Đơn giá net kho
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="exWarehouseUnitPrice"
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="exWarehouseUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Người quản lý
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="handlerId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="handlerId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Ghi chú
                        </label>
                        <div className="form-control-wrap">
                          <textarea
                            rows={3}
                            style={{ height: 'unset' }}
                            className="form-control"
                            name="note"
                            ref={register({})}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4"></Row>

                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">
                        Đơn vị vận tải và kho xuất
                      </BlockTitle>
                    </Col>

                    <Table className="table table-bordered">
                      <tbody>
                        <tr className="text-center">
                          <td>Tên đơn vị vận tải</td>
                          <td>Kho</td>
                          <td>Số lượng</td>
                          <td>Số tiền(đ)</td>
                        </tr>
                        {deliveryProvider?.map((c, i) => (
                          <tr key={i}>
                            <td>{c.deliveryProviderName}</td>
                            <td>{c.warehouseName}</td>
                            <td className="text-right">
                              <NumericFormat
                                value={+c.numOfContainer}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td className="text-right">
                              <NumericFormat
                                value={+c.deliveryFeeExternal}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={2}>Tổng cộng(đ)</td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={'text'}
                              value={numOfContainer}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={'text'}

                              value={deliveryFee}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </Row>

                  <Row className="mb-4"></Row>

                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">Phí cảng bãi</BlockTitle>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Phí nâng(đ)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="liftOnFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Phí hạ(đ)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="liftOffFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />

                        </div>
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Bồi dưỡng nâng hạ(đ)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="inDriverFosteringUpDownContainerFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          CSHT(đ)
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="infrastructureFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4"></Row>

                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">Bảo hiểm</BlockTitle>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ lệ bảo hiểm(%)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="insuranceRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={4}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="insuranceRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ giá<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="insuranceExchangeRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="insuranceExchangeRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ lệ thuế(%)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="insuranceTax"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={4}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="insuranceTax"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tiền bảo hiểm($)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={insuranceUsdFee}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tiền bảo hiểm(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={insuranceFee}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Nhà cung cấp BH
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="insuranceProviderId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={customerOptions.filter(e => e.data.type === 'IN')}
                                value={
                                  customerOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4"></Row>

                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">Phí tàu quốc tế - PTQT</BlockTitle>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Cước/cont($) <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeUnitPrice"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ giá <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeExchangeRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeExchangeRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>



                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Cước($)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeUnitPrice * numOfContainer}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Cước(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeSubtotal}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Bill tàu/bộ <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeebillFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeebillFee"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Seal/con{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeSealFeePerContainer"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeSealFeePerContainer"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Seal($)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={
                              shipFeeSealFeePerContainer * numOfContainer
                            }
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Nhà cung cấp phí tàu
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeProviderId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={customerOptions.filter(e => e.data.type === 'IN')}
                                value={
                                  customerOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeProviderId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ lệ thuế(%){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeVatRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={4}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeVatRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4 border-top mt-3 pt-3">
                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền PTQT trước thuế(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeSubtotalBeforeTax}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>



                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền thuế(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeSubtotalTax}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền PTQT sau thuế(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeSubtotalIncludeTax}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-4 border-top mt-3 pt-3">
                    <Col size={12}>
                      <BlockTitle tag="h5">Phí hải quan</BlockTitle>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Phí dịch vụ hải quan{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeCustomFee"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeCustomFee"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>


                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Nhà cung cấp phí hải quan <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="shipFeeCustomFeeProviderId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                isClearable
                                ref={ref}
                                name={name}
                                options={customerOptions.filter(e => e.data.type === 'IN')}
                                value={
                                  customerOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val?.value || null);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="shipFeeCustomFeeProviderId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền thuế(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeCustomFeeTax}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label className="form-label" >
                          Thành tiền hải quan(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={shipFeeCustomFeeAfterTax}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">Chi phí cố định</BlockTitle>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Tỉ giá <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="baseFeeExchangeRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="baseFeeExchangeRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Đơn giá túi($)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="packUnitPrice"
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="packUnitPrice"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Túi(đ)
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={baseFeePackageFee}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          phí hoa hồng($/tấn)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="baseFeeCommissionFeePerWeightRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="baseFeeCommissionFeePerWeightRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Hoa Hồng
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={baseFeeCommissionFee}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Phí NH + công đóng($)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="baseFeeBankFeePerCont"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                max={100}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="baseFeeBankFeePerCont"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Phí NH + công đóng
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={baseFeeBankFee}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="2">
                      <div className="form-group">
                        <label className="form-label" >
                          Người nhận HH
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="commissionProviderId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={customerOptions.filter(e => e.data.type === 'IN')}
                                value={
                                  customerOptions.find(
                                    (c) => c.value === value
                                  ) || null
                                }
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 g-2">
                    <Col size={12}>
                      <BlockTitle tag="h5">Tổng cộng</BlockTitle>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <NumericFormat
                            disabled
                            className="form-control"
                            type="text"
                            value={total}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>


                    <Col size="12" className={"mt-4"}>
                      {(data?.isCreateDebtProvider || data?.isCreateDebtCustomFeeProvider)
                        ? <Col size={12} className={'pl-0'}>
                          <strong className="text-danger">
                            hệ thống sẽ tự cập nhật công nợ trong trường hợp có thay đổi dữ liệu và đã tạo công nợ trước đó
                          </strong>
                        </Col>
                        : ''}
                      <Button
                        className={`mr-2`}
                        color="primary"
                        type="button"
                        onClick={handleSubmit(onHandleSubmit)}
                        disabled={loading}
                      >
                        <span>Lưu hợp đồng</span>
                      </Button>
                      {id && !isDirty && (
                        <>
                          <Button
                            className={`mr-2 text-white btn ${data?.isCreateDebtProvider ? 'bg-danger' : 'bg-secondary'}`}
                            type="button"
                            onClick={() => {
                              data?.isCreateDebtProvider
                                ? setView({ removeDebt: true })
                                : setView({ createDebt: true })
                            }}
                            disabled={loading}
                          >
                            {data?.isCreateDebtProvider ? <span>Xoá công nợ NCC phí tàu </span> : <span>Tạo công nợ NCC phí tàu </span>}
                          </Button>

                          <Button
                            className={`mr-2 text-white btn ${data?.isCreateDebtCommissionFee ? 'bg-danger' : 'bg-secondary'}`}
                            type="button"
                            onClick={() => {
                              data?.isCreateDebtCommissionFee
                                ? setView({ removeDebtCommissionFee: true })
                                : setView({ createDebtCommissionFee: true });
                            }}
                            disabled={loading}
                          >
                            {data?.isCreateDebtCommissionFee ? <span>Xoá công nợ hoa hồng</span> : <span>Tạo công nợ hoa hồng</span>}
                          </Button>
                          <Button
                            className={`mr-2 text-white btn ${data?.isCreateDebtCustomFeeProvider ? 'bg-danger' : 'bg-secondary'}`}
                            type="button"
                            onClick={() => {
                              data?.isCreateDebtCustomFeeProvider
                                ? setView({ removeDebtCustomFeeProvider: true })
                                : setView({ createDebtCustomFeeProvider: true });
                            }}
                            disabled={loading}
                          >
                            {data?.isCreateDebtCustomFeeProvider ? <span>Xoá công nợ NCC phí hải quan</span> : <span>Tạo công nợ NCC phí hải quan</span>}
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.createDebt} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn tạo công nợ phí tàu {!shipFeeCustomFeeProviderId ? 'và phí hải quan' : ''} không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    createDebt();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.createDebtCustomFeeProvider} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn tạo công nợ DV hải quan?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    createDebtCustomFeeProvider();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.createDebtCommissionFee} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn tạo công nợ Phí hoa hồng?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    createDebtCommissionFee();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.removeDebt} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá công nợ phí cước tàu?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    removeDebt();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.removeDebtCustomFeeProvider} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá công nợ phí hải quan?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    removeDebtCustomFeeProvider();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.removeDebtCommissionFee} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá công nợ phí hoa hồng?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                  disabled={loading}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  disabled={loading}
                  onClick={(ev) => {
                    ev.preventDefault();
                    removeDebtCommissionFee();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

      </Content>
    </React.Fragment>
  );
};

export default BillExternalContractCreate;
